import cloneDeep from "lodash.clonedeep";
import {hasOwn} from "~/utils";
import { GlobalWidgetModules } from '~/enums/siteEnum'

let uuid = 0
export class BaseWidgetModel {
    constructor(options) {
      if (options) {
        Object.assign(this, options)
        // console.log(options)
      }
      this.__siteId = () => {
       return 'site-widget-' + (++uuid) + (Date.now() * parseInt(Math.random() * 100))
      }
      const __getId = () => {
        let result = options?.id
        if (GlobalWidgetModules.includes(options?.moduleName)) {
          result = result.includes(options.moduleName) ? result : `${options?.id}-${options.moduleName}`
        } else if (!result) {
          result = this.__siteId()
        }
        return result
      }
      this.name = 'BaseWidgetModel'
      this.__sortIndex = 0
      this.id = __getId()
      this.value = options?.value || undefined
      // this.__global = false; // 是否是全局，是全局的话就不需要在列表中显示
      this.name = options?.name || this.constructor.name
      this.visible = typeof options === 'object' ? (options.visible === undefined ? true : options.visible) : true
      this.titleStroke = hasOwn(options, 'titleStroke', '', '')
      this.subTitleStroke = hasOwn(options, 'subTitleStroke', '', '')
      /*
      *  获取展示信息
      * */
      this.getMenuInfo = () => {
        return {
          id: this.id, // 唯一id，方便找到dom跳转
          title: 'title', // 显示文字，多语言的key
          model: TitleWidgetModel,
          icon: 'icon', // 小图标
          draggable: true, // 是否可拖拽
        }
      }
    }

    langChange(langKey, isAdd) {
      //
    }

    clone() {
      const newModel = cloneDeep(this)
      newModel.id = this.__siteId()
      return new this.constructor(newModel)
    }
  }

  export class TitleWidgetModel extends BaseWidgetModel {
    constructor(options) {
      super(options);
      this.name = 'TitleWidgetModel'

      this.title = options?.title || 'title'
      this.getMenuInfo = () => {
        return {
          id: this.id,
          title: 'title',
          model: TitleWidgetModel,
          icon: '',
          draggable: true,
        }
      }
    }
  }
